import state from "./moduleUserEditState.js";
import mutations from "./moduleUserViewEditMutations.js";
import actions from "./moduleUserEditActions.js";
import getters from "./moduleUserEditGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
